import { IWorktime } from '../../types/coworking';

export const getCoworkingAccessLabel = (worktime: IWorktime) => {
  const { isAllWeek, isRoundTheClock, timeFrom, timeTo } = worktime;

  const allWeekLabel = isAllWeek ? 'Ежедневно' : 'Пн — пт';
  const accessTimeLabel = isRoundTheClock ? 'круглосуточно' : `с\u00A0${timeFrom}\u00A0до\u00A0${timeTo}`;

  return `${allWeekLabel}, ${accessTimeLabel}`;
};
